/**
 * A tiny framework-agnostic signal for "start a new chat". The sidebar button
 * and the ⌘⇧O command live in the app shell — OUTSIDE the ChatRunProvider — so
 * they can't call its `reset()` directly. They fire this signal instead; the
 * provider subscribes and clears any stuck or errored run before the welcome
 * view shows. (Navigating to `/chat` alone doesn't reset an errored `isNew`
 * run, and is a no-op when already on `/chat` — which is exactly when a stuck
 * thread would otherwise linger over the welcome screen.)
 */
const listeners = new Set<() => void>();

export function requestNewChat(): void {
  for (const listener of listeners) listener();
}

export function subscribeNewChat(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
